import { render, staticRenderFns } from "./InterventionHandler.vue?vue&type=template&id=132a606e&"
import script from "./InterventionHandler.vue?vue&type=script&lang=js&"
export * from "./InterventionHandler.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports